import { useEffect } from "react";
import { Navigate } from "react-router";
import { useAppSelector, useAppDispatch } from "../../redux/store";
import { useSnackbar } from "notistack";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { validateUserToken } from "../../redux/slices/loginSlice";
import LoginForm from "./components/LoginForm";

const Login = () => {
  const {
    user,
    loginSuccess,
    loginError,
    magicLinkError,
    magicLinkSent,
    userIsValid,
    needValidation,
  } = useAppSelector((state) => state.login);
  const dispatch = useAppDispatch();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    if (needValidation && !userIsValid) {
      dispatch(validateUserToken());
    }
  }, [dispatch, needValidation, userIsValid]);

  useEffect(() => {
    if (loginSuccess) {
      enqueueSnackbar("Login successful!", { variant: "success" });
    }
    if (magicLinkSent) {
      enqueueSnackbar(
        "Secure link sent successfully. Please check your email.",
        {
          variant: "success",
          persist: true,
          action: (key) => (
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={() => closeSnackbar(key)}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          ),
        }
      );
    }
    if (loginError) {
      enqueueSnackbar(`Login failed. ${loginError}.`, { variant: "error" });
    }
    if (magicLinkError) {
      enqueueSnackbar(`Secure link error. ${magicLinkError}.`, {
        variant: "error",
      });
    }
  }, [
    enqueueSnackbar,
    closeSnackbar,
    loginSuccess,
    loginError,
    magicLinkError,
    magicLinkSent,
  ]);

  if (loginSuccess || userIsValid) {
    return (
      <Navigate
        to={`${user?.role === "admin" ? "/dashboard" : "/project-home"}`}
      />
    );
  }

  return <LoginForm />;
};

export default Login;
